declare global {
    interface Window {
        __CONFIG__?: Record<string, string>;
    }
}

type TRuntimeConfigKey =
    | "VITE_AUTH0_DOMAIN"
    | "VITE_AUTH0_CLIENT_ID"
    | "VITE_AUTH0_AUDIENCE"
    | "VITE_DD_RUM_APPLICATION_ID"
    | "VITE_DD_RUM_CLIENT_TOKEN"
    | "VITE_DD_ENV"
    | "VITE_APP_VERSION";

/**
 * Read a runtime configuration value injected via window.__CONFIG__.
 * Throws if the key is missing — call sites must not swallow the error.
 */
export function getConfig(key: TRuntimeConfigKey): string {
    const cfg = window.__CONFIG__;
    if (!cfg || !cfg[key]) {
        throw new Error(`Runtime config key "${key}" is not set. Check config.js is loaded.`);
    }
    return cfg[key]!;
}

/**
 * Read a runtime configuration value, returning undefined when absent.
 * Use for optional keys (e.g. Datadog RUM tokens in local dev).
 */
export function getOptionalConfig(key: TRuntimeConfigKey): string | undefined {
    const value = window.__CONFIG__?.[key];
    return value === "" ? undefined : value;
}
